/**
 * Utility functions for WhatsApp links and phone number formatting.
 *
 * WhatsApp wa.me links require:
 * 1. Digits only (no '+', no spaces, no dashes, no parentheses).
 * 2. Country code must be included.
 *
 * If a 10-digit number is passed without country code, '91' (India) is prepended.
 */

export const formatWhatsAppNumber = (phone?: string | number | null): string => {
  if (!phone) return "";
  let digits = String(phone).replace(/[^0-9]/g, "");
  if (!digits) return "";

  // Strip international prefix '00' if present
  if (digits.startsWith("00")) {
    digits = digits.slice(2);
  } else if (digits.startsWith("0") && digits.length === 11) {
    // Leading 0 followed by 10 digits (e.g. 09876543210)
    digits = "91" + digits.slice(1);
  } else if (digits.length === 10) {
    // 10 digits without country code -> default to India (91)
    digits = "91" + digits;
  }

  return digits;
};

export const getWhatsAppUrl = (
  phone?: string | number | null,
  text?: string
): string => {
  const cleanPhone = formatWhatsAppNumber(phone);
  if (!cleanPhone) return "";
  const query = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${cleanPhone}${query}`;
};
